var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoEmail(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.098,
    height: 13.818,
    viewBox: "0 0 20.098 13.818",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18.842,80H1.256A1.257,1.257,0,0,0,0,81.256v.715l10.049,4.256L20.1,81.97v-.713A1.257,1.257,0,0,0,18.842,80Z",
    transform: "translate(0 -80)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 3.336)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.294,169.111a.622.622,0,0,1-.49,0L0,164.96v9.226a1.257,1.257,0,0,0,1.256,1.256H18.842a1.257,1.257,0,0,0,1.256-1.256V164.96Z",
    transform: "translate(0 -164.96)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoEmail);
export default __webpack_public_path__ + "static/media/ico-email.947ff5e58b148d4a8544333051426818.svg";
export { ForwardRef as ReactComponent };